import { type ComponentRef, Directive, type Type, inject, Input } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { FormsViewsContextMenuComponent, type FormsPanelNavigation, type FormsPickerView } from '../components/forms-views-context-menu/forms-views-context-menu.component';
import { FormsWorkspaceStore } from '../services/forms-workspace.store';

@Directive({
  selector: '[appFormsViewsContextMenu]',
  standalone: true,
})
export class FormsViewsContextMenuDirective extends ContextMenuDirective {
  @Input() public override stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() public override stchPopoverPlacement: PopoverPlacement = 'bottomLeft';
  public readonly appFormsViewsContextMenuOpened = outputFromObservable(this.contextMenuOpened);

  @Input() public appFormsViewsContextMenuFolders = false;
  @Input() public appFormsViewsContextMenuNavigate?: (view: FormsPanelNavigation) => void;
  @Input() public appFormsViewsContextMenuViews: readonly FormsPickerView[] = [];
  @Input() public appFormsViewsContextMenuHasSearchResults = false;

  private readonly listStore = inject(FormsWorkspaceStore);

  protected registerComponent(): Type<FormsViewsContextMenuComponent> {
    return FormsViewsContextMenuComponent;
  }

  protected registerInstance(componentRef: ComponentRef<FormsViewsContextMenuComponent>): void {
    componentRef.instance.listStore = this.listStore;
    componentRef.instance.foldersOpen = this.appFormsViewsContextMenuFolders;
    componentRef.instance.navigate = this.appFormsViewsContextMenuNavigate;
    componentRef.instance.views = this.appFormsViewsContextMenuViews;
    componentRef.instance.hasSearchResults = this.appFormsViewsContextMenuHasSearchResults;
  }
}
